import {useMount} from '@s-ui/react-hooks'

const EndIntegration = () => {
  useMount(() => {
    window.close()
  })

  return <></>
}
export default EndIntegration
